import { cx } from '@linaria/core';
import { useId } from 'react';
import { Chevron, SizeTransition } from '@utils/react';
import { heading, button, chevron, content, toggleDurationMs, accordion } from './accordion.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Accordion(props) {
  const fallbackId = `accordion-${useId()}`;
  const baseId = props.baseId ?? fallbackId;
  return /*#__PURE__*/jsxs("div", {
    className: cx(accordion, props.className),
    "data-theme": props.theme,
    children: [/*#__PURE__*/jsx(props.headingLevel, {
      className: heading,
      children: /*#__PURE__*/jsxs("button", {
        className: button,
        id: baseId,
        onClick: props.onToggle,
        "aria-haspopup": "listbox",
        "aria-expanded": true,
        "aria-controls": `${baseId}-content`,
        children: [/*#__PURE__*/jsx("span", {
          children: props.heading
        }), props.badge, /*#__PURE__*/jsx(Chevron, {
          className: chevron,
          vertical: true,
          inversed: props.expanded,
          size: props.theme === "compact" ? 10 : 12,
          lineWidth: props.theme === "compact" ? 1.5 : 2
        })]
      })
    }), /*#__PURE__*/jsx(SizeTransition, {
      in: props.expanded,
      timeout: toggleDurationMs,
      classNames: content,
      axis: "vertical",
      mountOnEnter: true,
      unmountOnExit: true,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: content,
        children: props.children
      })
    })]
  });
}

export { Accordion };
//# sourceMappingURL=accordion.js.map
